// Modernizr is imported in this component
// to set classes on `html` element
// so we can use them in our css.
// eslint-disable-next-line no-unused-vars
import Modernizr from 'modernizr';

// Provide a11y helper classes to detect source of focus event:
import focusSource from 'ally.js/esm/style/focus-source';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import browserHistory from './utils/browserHistory';
import mediaQueryListener from './utils/mediaQueryListener';

import './index.scss';

import App from 'components/App/App';

ReactDOM.render(
  <Router history={browserHistory}>
    <App />
  </Router>,
  document.getElementById('valeo-techassist-app')
);

mediaQueryListener.updateCurrentBreakpoint();
// Enable focus source detection:
focusSource();



// WEBPACK FOOTER //
// ./src/index.js